import _ from "classnames";
import h from "react";
import { renderToStaticMarkup as y } from "react-dom/server";
import { useSizeAttrs as N } from "../utils/hooks/useSizeAttrs.esm.js";
const U = "_link_bop5k_1", x = {
  link: U
}, z = (t) => {
  if (!t) return;
  const e = y(t);
  return `url("data:image/svg+xml,${encodeURIComponent(e)}")`;
}, A = ({
  as: t = "a",
  centreAlign: e = !1,
  children: r = null,
  className: i,
  dataTestId: s = null,
  disabled: o,
  href: d,
  icon: l,
  iconRight: c = !1,
  isButton: n = !1,
  size: m = "large",
  standalone: u = !1,
  underline: f = !0,
  white: v = !1,
  focusable: k = !1,
  ...p
}) => {
  const g = N(m, {}), a = n ? "button" : t, b = z(l);
  return h.createElement(
    a,
    {
      "aria-disabled": o ? "" : void 0,
      className: _(x.link, i),
      "data-testid": s,
      href: o || n || a === "span" ? void 0 : d,
      role: a === "button" ? "button" : "link",
      ...g,
      "data-icon": l ? "" : void 0,
      "data-icon-right": c ? "" : void 0,
      "data-underline": f ? "" : void 0,
      "data-standalone": u ? "" : void 0,
      "data-centre-align": e ? "" : void 0,
      "data-focusable": k ? "" : void 0,
      style: {
        "--link-icon-url": b,
        "--link-color-override": v ? "var(--color-global-white)" : ""
      },
      ...p
    },
    r
  );
};
A.displayName = "BaseLink";
export {
  A as BaseLink
};
